import { render, staticRenderFns } from "./ChatVideo.vue?vue&type=template&id=642a03ab&scoped=true"
import script from "./ChatVideo.vue?vue&type=script&lang=js"
export * from "./ChatVideo.vue?vue&type=script&lang=js"
import style0 from "./ChatVideo.vue?vue&type=style&index=0&id=642a03ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642a03ab",
  null
  
)

export default component.exports